<template>
  <div :id="`searchForm-${type}`">
    <div v-show="formMode === 'default'">
      <div
        class="searchformSelectedTag"
        :style="`width: calc(100% - ${scrollBarWidth}px)`"
      >
        <SearchCondition :querys="conditionsQuery" :has-header="false" />
      </div>

      <FormSearchKeyword
        class="searchKeyword"
        :value="freeWord"
        @call-input-change="freeWord = $event"
        @submit-keyword="searchSubmit('freeword')"
      />

      <div class="searchform">
        <section class="searchformSec">
          <HeadingLv3 text="病院所在地" />
          <InputInlineText
            placeholder="選択されていません"
            :value="selectedPrefecture"
            :readonly="true"
            @click="() => changeFormMode('area')"
          ></InputInlineText>
        </section>

        <section v-if="type === 'latter'" class="searchformSec">
          <HeadingLv3 text="専門研修プログラム科目" />
          <FormCheckboxButtons
            :items="
              isShowAllProgramSubjects
                ? programSubjects
                : programSubjects.filter((_, index) => index < 6)
            "
            @change-checkbox="setConditionsCheckbox('sj', $event)"
          />
          <Button
            v-if="!isShowAllProgramSubjects"
            :handleClick="() => (isShowAllProgramSubjects = true)"
            label="さらに表示する"
            lightgray
          />
        </section>
        <section class="searchformSec">
          <HeadingLv3 text="病院種別" />
          <FormCheckboxButtons
            :items="hospitalClass"
            @change-checkbox="setConditionsCheckbox('cl', $event)"
          />
        </section>
        <section v-if="type === 'latter'" class="searchformSec">
          <HeadingLv3 text="プログラムの特徴" />
          <FormCheckboxButtons
            :items="featureTag"
            @change-checkbox="setConditionsCheckbox('pk', $event)"
          />
        </section>
        <section class="searchformSec">
          <HeadingLv3 text="救急指定" />
          <FormCheckboxButtons
            :items="designatedHospital"
            @change-checkbox="setConditionsCheckbox('dh', $event)"
          />
        </section>
        <section class="searchformSec">
          <HeadingLv3
            :text="type === 'hospital' ? 'こだわり条件' : '病院の特徴'"
          />
          <FormCheckboxButtons
            :items="
              isShowAllKeywords
                ? keywords
                : keywords.filter((_, index) => index < 6)
            "
            @change-checkbox="setConditionsCheckbox('kw', $event)"
          />
          <Button
            v-if="!isShowAllKeywords"
            :handleClick="() => (isShowAllKeywords = true)"
            label="さらに表示する"
            lightgray
          />
        </section>
        <section v-if="type === 'hospital'" class="searchformSec">
          <HeadingLv3 text="その他希望の条件" />
          <FormCheckboxButtons
            :items="otherConditions"
            @change-checkbox="setConditionsCheckbox('other', $event)"
          />
        </section>
        <section class="searchformSec">
          <HeadingLv3 text="病床数" />
          <div class="searchformRange">
            <div class="selectboxes">
              <Selectbox
                :id="`bed_num_lo-${type}`"
                :name="`bed_num_lo-${type}`"
                :options="bedNumList"
                :selected="currentConditions.bn.lo"
                @selection-change="setConditionsRange('bn', 'low', $event)"
              />
            </div>
            <span class="searchformRange_between">〜</span>
            <div class="selectboxes">
              <Selectbox
                :id="`bed_num_hi-${type}`"
                :name="`bed_num_hi-${type}`"
                :options="bedNumList"
                :selected="currentConditions.bn.hi"
                @selection-change="setConditionsRange('bn', 'high', $event)"
              />
            </div>
          </div>
        </section>
        <section v-if="type === 'latter'" class="searchformSec">
          <HeadingLv3 text="当科病床数" />
          <div class="searchformRange">
            <div class="selectboxes">
              <Selectbox
                :id="`department_bed_num_lo-${type}`"
                :name="`department_bed_num_lo-${type}`"
                :options="departmentBedNumList"
                :selected="currentConditions.sb.lo"
                @selection-change="setConditionsRange('sb', 'low', $event)"
              />
            </div>
            <span class="searchformRange_between">〜</span>
            <div class="selectboxes">
              <Selectbox
                :id="`department_bed_num_hi-${type}`"
                :name="`department_bed_num_hi-${type}`"
                :options="departmentBedNumList"
                :selected="currentConditions.sb.hi"
                @selection-change="setConditionsRange('sb', 'high', $event)"
              />
            </div>
          </div>
        </section>
        <section v-if="type === 'latter'" class="searchformSec">
          <HeadingLv3 text="当科在籍研修医数" />
          <div class="searchformRange">
            <div class="selectboxes">
              <Selectbox
                :id="`resident_num_lo-${type}`"
                :name="`resident_num_lo-${type}`"
                :options="residentNumList"
                :selected="currentConditions.mi.lo"
                @selection-change="setConditionsRange('mi', 'low', $event)"
              />
            </div>
            <span class="searchformRange_between">〜</span>
            <div class="selectboxes">
              <Selectbox
                :id="`resident_num_hi-${type}`"
                :name="`resident_num_hi-${type}`"
                :options="residentNumList"
                :selected="currentConditions.mi.hi"
                @selection-change="setConditionsRange('mi', 'high', $event)"
              />
            </div>
          </div>
        </section>
        <section v-if="type === 'latter'" class="searchformSec">
          <HeadingLv3 text="当科指導医数" />
          <div class="searchformRange">
            <div class="selectboxes">
              <Selectbox
                :id="`instructor_num_lo-${type}`"
                :name="`instructor_num_lo-${type}`"
                :options="instructorNumList"
                :selected="currentConditions.si.lo"
                @selection-change="setConditionsRange('si', 'low', $event)"
              />
            </div>
            <span class="searchformRange_between">〜</span>
            <div class="selectboxes">
              <Selectbox
                :id="`instructor_num_hi-${type}`"
                :name="`instructor_num_hi-${type}`"
                :options="instructorNumList"
                :selected="currentConditions.si.hi"
                @selection-change="setConditionsRange('si', 'high', $event)"
              />
            </div>
          </div>
        </section>
        <section class="searchformSec">
          <HeadingLv3 text="医師数" />
          <div class="searchformRange">
            <div class="selectboxes">
              <Selectbox
                :id="`doctor_num_lo-${type}`"
                :name="`doctor_num_lo-${type}`"
                :options="doctorNumList"
                :selected="currentConditions.dn.lo"
                @selection-change="setConditionsRange('dn', 'low', $event)"
              />
            </div>
            <span class="searchformRange_between">〜</span>
            <div class="selectboxes">
              <Selectbox
                :id="`doctor_num_hi-${type}`"
                :name="`doctor_num_hi-${type}`"
                :options="doctorNumList"
                :selected="currentConditions.dn.hi"
                @selection-change="setConditionsRange('dn', 'high', $event)"
              />
            </div>
          </div>
        </section>
        <section class="searchformSec">
          <HeadingLv3 text="募集定員" />
          <div class="searchformRange">
            <div class="selectboxes">
              <Selectbox
                :id="`positions_num_lo-${type}`"
                :name="`positions_num_lo-${type}`"
                :options="positionsNumList"
                :selected="currentConditions.pn.lo"
                @selection-change="setConditionsRange('pn', 'low', $event)"
              />
            </div>
            <span class="searchformRange_between">〜</span>
            <div class="selectboxes">
              <Selectbox
                :id="`positions_num_hi-${type}`"
                :name="`positions_num_hi-${type}`"
                :options="positionsNumList"
                :selected="currentConditions.pn.hi"
                @selection-change="setConditionsRange('pn', 'high', $event)"
              />
            </div>
          </div>
        </section>
        <section class="searchformSec">
          <HeadingLv3 text="年収" :setLabelSlot="type === 'latter'">
            <span>＊卒後3年次の数値</span>
          </HeadingLv3>
          <div class="searchformRange">
            <div class="selectboxes">
              <Selectbox
                :id="`income_lo-${type}`"
                :name="`income_lo-${type}`"
                :options="incomeList"
                :selected="currentConditions.ai.lo"
                @selection-change="setConditionsRange('ai', 'low', $event)"
              />
            </div>
            <span class="searchformRange_between">〜</span>
            <div class="selectboxes">
              <Selectbox
                :id="`income_hi-${type}`"
                :name="`income_hi-${type}`"
                :options="incomeList"
                :selected="currentConditions.ai.hi"
                @selection-change="setConditionsRange('ai', 'high', $event)"
              />
            </div>
          </div>
        </section>
        <section class="searchformSec">
          <HeadingLv3 text="当直回数" :setLabelSlot="type === 'latter'">
            <span>＊卒後3年次の数値</span>
          </HeadingLv3>
          <div class="searchformRange">
            <div class="selectboxes">
              <Selectbox
                :id="`shifts_num_lo-${type}`"
                :name="`shifts_num_lo-${type}`"
                :options="shiftsNumList"
                :selected="currentConditions.sn.lo"
                @selection-change="setConditionsRange('sn', 'low', $event)"
              />
            </div>
            <span class="searchformRange_between">〜</span>
            <div class="selectboxes">
              <Selectbox
                :id="`shifts_num_hi-${type}`"
                :name="`shifts_num_hi-${type}`"
                :options="shiftsNumList"
                :selected="currentConditions.sn.hi"
                @selection-change="setConditionsRange('sn', 'high', $event)"
              />
            </div>
          </div>
        </section>
      </div>

      <div
        class="searchformBar"
        :style="`width: calc(100% - ${scrollBarWidth}px)`"
      >
        <div class="searchformBar_inner">
          <button
            type="button"
            @click="searchSubmit('conditions')"
            class="searchformBtn"
          >
            検索する
            <span> ({{ numberFormatAddComma(resultCount) }}件) </span>
          </button>
          <CheckboxButton
            v-if="$store.state.isLogin"
            style="margin-top: -20px;"
            label="検索条件を保存する"
            value="1"
            :id="`searchCoditionSaveFrg-${type}`"
            :checked="$store.state.searchCoditionSaveFrg"
            @call-input-change="setSaveFlg"
            inline
          />
        </div>
        <div class="searchformBar_reset">
          <button type="button" @click="clearConditions">
            検索条件のリセット
          </button>
        </div>
      </div>
    </div>

    <div v-show="formMode === 'area'">
      <div class="searchform">
        <section class="searchformSec">
          <HeadingLv3 text="エリア選択" />
          <template v-for="(area, i) in areas" :key="i">
            <FormAreaCheckbox
              :id="`area${i}-${type}`"
              :label="area.name"
              :items="area.prefectures"
              :gatAllOnce="true"
              @select-area="selectArea(i, $event)"
              @check-prefecture="checkPrefecture(i, $event)"
            />
          </template>

          <Button
            label="決定"
            primary
            :handleClick="() => changeFormMode('default')"
          />
        </section>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
// eslint-disable-next-line
import {
  defineComponent,
  ref,
  reactive,
  computed,
  onMounted,
  PropType
} from 'vue'
import { useStore } from 'vuex'
import { useRouter } from 'vue-router'
import HeadingLv3 from '@/components/elements/HeadingLv3.vue'
import Button from '@/components/elements/Button.vue'
import CheckboxButton from '@/components/elements/InputCheckboxButton.vue'
import Selectbox from '@/components/elements/InputSelectbox_new.vue'
import InputInlineText from '@/components/elements/InputInlineText.vue'
import FormSearchKeyword from '@/components/block/FormSearchKeyword.vue'
import FormAreaCheckbox from '@/components/block/FormAreaCheckbox.vue'
import FormCheckboxButtons from '@/components/block/FormCheckboxButtons.vue'
import SearchCondition from '@/components/block/SearchCondition.vue'
import { axiosSetting } from '@/utils/axiosSetting'
import { getSearchQuery } from '@/utils/searchMethods'
import { numberFormatAddComma, isValidJson } from '@/utils/commonMethods'
import { getCookie } from '@/utils/cookie'
import { Checkbox, SelectOption } from '@/types/InputItems'

interface Master {
  id: string
  opt_id: string
  option_name: string
  area?: string
}
interface ConditionsObject {
  [key: string]: any
}
interface Pref {
  label: string
  value: string
  id: string
  area: string
  checked?: boolean
}

export default defineComponent({
  components: {
    HeadingLv3,
    Button,
    CheckboxButton,
    Selectbox,
    InputInlineText,
    FormSearchKeyword,
    FormAreaCheckbox,
    FormCheckboxButtons,
    SearchCondition
  },

  props: {
    type: {
      type: String as PropType<'hospital' | 'latter'>,
      default: 'hospital'
    },
    formMode: {
      type: String,
      required: true
    },
    changeFormMode: {
      type: Function as PropType<(mode: string) => void>,
      required: true
    },
    scrollBarWidth: {
      type: Number,
      default: 0
    }
  },

  setup(props) {
    const store = useStore()
    const router = useRouter()

    // 最後の検索条件を取得
    const getLastSearchCondition = () => {
      // Cookieから検索条件を取得
      const cookieName =
        props.type === 'hospital'
          ? 'lastSearchCondition'
          : 'lastSearchLatterCondition'
      const cookieLastSearchCondition = getCookie(cookieName)
      // CookieなかったらNullを返却
      if (!cookieLastSearchCondition) return null
      // エンコードされて保存されているのでデコード
      const cond = decodeURIComponent(cookieLastSearchCondition).split('=')[1]
      // Jsonにパースして返却(有効なJsonじゃなかったらNullを返却)
      return isValidJson(cond) ? JSON.parse(cond) : null
    }
    // 最後の検索条件をセット
    const lastConditions = getLastSearchCondition()

    /* --------------------------------------------------
    * フォームの要素の項目をセット
    -------------------------------------------------- */

    // フリーワード
    const freeWord = ref('')
    if (lastConditions?.free_word) freeWord.value = lastConditions.free_word

    // 病院所在地
    const areas: any[] = reactive([])
    const tempAreas: string[] = []
    const tempItems: Pref[] = []
    store.state.master.prefectures.forEach((el: Master) => {
      if (el.opt_id === '0') return
      if (el.area) tempAreas.push(el.area)

      tempItems.push({
        label: el.option_name,
        value: el.opt_id || '',
        id: 'prefecture' + `-${props.type}-` + el.opt_id,
        area: el.area || '',
        checked: lastConditions?.prefectures?.includes(el.opt_id) || false
      })
    })
    const areaNames = Array.from(new Set(tempAreas))
    areaNames.forEach((area) => {
      areas.push({
        name: area,
        prefectures: tempItems.filter((item) => area === item.area)
      })
    })
    // 専門研修プログラム科目
    const programSubjects: Checkbox[] = reactive([])
    const isShowAllProgramSubjects = ref(false)
    if (props.type === 'latter') {
      store.state.master.programSubjects.forEach((el: Master) => {
        if (el.opt_id === '0') return

        programSubjects.push({
          label: el.option_name,
          value: el.opt_id || '',
          id: 'programSubjects' + el.opt_id,
          checked:
            lastConditions?.program_subjects?.includes(el.opt_id) || false
        })
      })
    }
    // 病院種別
    const hospitalClass: Checkbox[] = reactive([])
    store.state.master.hospitalClass.forEach((el: Master) => {
      if (el.opt_id === '0') return

      hospitalClass.push({
        label: el.option_name,
        value: el.opt_id || '',
        id: 'hospitalClass' + `-${props.type}-` + el.opt_id,
        checked: lastConditions?.hospital_class?.includes(el.opt_id) || false
      })
    })
    // プログラムの特徴
    const featureTag: Checkbox[] = reactive([])
    if (props.type === 'latter') {
      store.state.master.featureTag.forEach((el: Master) => {
        if (el.opt_id === '0') return

        featureTag.push({
          label: el.option_name,
          value: el.opt_id || '',
          id: 'featureTag' + `-${props.type}-` + el.opt_id,
          checked: lastConditions?.feature_tag?.includes(el.opt_id) || false
        })
      })
    }
    // 救急指定
    const designatedHospital: Checkbox[] = reactive([])
    store.state.master.designatedHospital.forEach((el: Master) => {
      if (el.opt_id === '0') return

      designatedHospital.push({
        label: el.option_name,
        value: el.opt_id || '',
        id: 'designatedHospital' + `-${props.type}-` + el.opt_id,
        checked:
          lastConditions?.designated_hospital?.includes(el.opt_id) || false
      })
    })
    // 病院：こだわり条件 / 専門研修：病院の特徴
    const keywords: Checkbox[] = reactive([])
    const isShowAllKeywords = ref(false)
    store.state.master.keywords.forEach((el: Master) => {
      if (el.opt_id === '0') return

      keywords.push({
        label: el.option_name,
        value: el.opt_id || '',
        id: 'keywords' + `-${props.type}-` + el.opt_id,
        checked:
          lastConditions?.discerning_conditions?.includes(el.opt_id) || false
      })
    })
    // その他希望の条件
    const otherConditions: Checkbox[] = reactive([])
    if (props.type === 'hospital') {
      otherConditions.push(
        {
          label: '賞与あり',
          value: 'rb',
          id: 'rb' + `-${props.type}`,
          checked: lastConditions?.bonus || false
        },
        {
          label: '時間外勤務あり',
          value: 'ro',
          id: 'ro' + `-${props.type}`,
          checked: lastConditions?.overtime_hours_mavg || false
        },
        {
          label: '研修医のための宿舎あり',
          value: 'rh',
          id: 'rh' + `-${props.type}`,
          checked: lastConditions?.house || false
        }
      )
      if (store.state.isLogin) {
        otherConditions.push({
          label: '出身大学の先輩あり',
          value: 'gs',
          id: 'gs' + `-${props.type}`,
          checked: lastConditions?.j_graduating_school || false
        })
      }
    }
    // セレクトオブジェクトのデフォルト値
    const selectDefault = {
      label: '選択してください',
      value: ''
    }
    // 病床数
    const bedNumList: SelectOption[] = reactive([selectDefault])
    for (let i = 0; i <= 1500; i = i + 150) {
      bedNumList.push({
        label: i + '床',
        value: String(i)
      })
    }
    // 当科病床数
    const departmentBedNumList: SelectOption[] = reactive([selectDefault])
    const departmentBedOption = [0, 100, 200, 400, 600, 900]
    departmentBedOption.forEach((num: number) => {
      departmentBedNumList.push({
        label: num + '床',
        value: String(num)
      })
    })
    // 当科在籍研修医数
    const residentNumList: SelectOption[] = reactive([selectDefault])
    const residentNumOption = [0, 3, 5, 10, 20]
    residentNumOption.forEach((num: number) => {
      residentNumList.push({
        label: num + '人',
        value: String(num)
      })
    })
    // 当科指導医数
    const instructorNumList: SelectOption[] = reactive([selectDefault])
    const instructorNumOption = [0, 3, 5, 10, 20]
    instructorNumOption.forEach((num: number) => {
      instructorNumList.push({
        label: num + '人',
        value: String(num)
      })
    })
    // 医師数
    const doctorNumList: SelectOption[] = reactive([selectDefault])
    for (let i = 0; i <= 1100; i = i + 50) {
      const val = i === 0 ? 10 : i
      doctorNumList.push({
        label: val + '人',
        value: String(val)
      })
    }
    // 募集定員
    const positionsNumList: SelectOption[] = reactive([selectDefault])
    for (
      let i = 0;
      i <= 100;
      i = i + (i == 0 ? 1 : i == 1 ? 4 : i > 15 ? 10 : 5)
    ) {
      positionsNumList.push({
        label: i + '人',
        value: String(i)
      })
    }
    // 年収
    const incomeList: SelectOption[] = reactive([selectDefault])
    const incomeDefaultLowNum = props.type === 'latter' ? 400 : 300
    for (let i = incomeDefaultLowNum; i <= 1100; i = i + 100) {
      incomeList.push({
        label: i + '万円',
        value: String(i)
      })
    }
    // 当直回数
    const shiftsNumList: SelectOption[] = reactive([selectDefault])
    for (let i = 0; i <= 8; i++) {
      shiftsNumList.push({
        label: i + '回',
        value: String(i)
      })
    }

    /* --------------------------------------------------
    * 検索条件
    -------------------------------------------------- */

    // 現在の検索条件
    const currentConditions: ConditionsObject = reactive({
      pr: {
        type: 'array',
        values: lastConditions?.prefectures || []
      },
      sj: {
        type: 'array',
        values: lastConditions?.program_subjects || []
      },
      cl: {
        type: 'array',
        values: lastConditions?.hospital_class || []
      },
      pk: {
        type: 'array',
        values: lastConditions?.feature_tag || []
      },
      dh: {
        type: 'array',
        values: lastConditions?.designated_hospital || []
      },
      kw: {
        type: 'array',
        values: lastConditions?.discerning_conditions || []
      },
      rb: {
        type: 'boolean',
        checked: lastConditions?.bonus || false
      },
      ro: {
        type: 'boolean',
        checked: lastConditions?.overtime_hours_mavg || false
      },
      rh: {
        type: 'boolean',
        checked: lastConditions?.house || false
      },
      gs: {
        type: 'boolean',
        checked: lastConditions?.j_graduating_school || false
      },
      bn: {
        type: 'range',
        lo: lastConditions?.bed_num_lo || '',
        hi: lastConditions?.bed_num_hi || ''
      },
      sb: {
        type: 'range',
        lo: lastConditions?.department_bed_num_lo || '',
        hi: lastConditions?.department_bed_num_hi || ''
      },
      mi: {
        type: 'range',
        lo: lastConditions?.resident_num_lo || '',
        hi: lastConditions?.resident_num_hi || ''
      },
      si: {
        type: 'range',
        lo: lastConditions?.instructor_num_lo || '',
        hi: lastConditions?.instructor_num_hi || ''
      },
      dn: {
        type: 'range',
        lo: lastConditions?.doctor_num_lo || '',
        hi: lastConditions?.doctor_num_hi || ''
      },
      pn: {
        type: 'range',
        lo:
          props.type === 'hospital'
            ? lastConditions?.positions_num_lo || ''
            : lastConditions?.recruitment_num_lo || '',
        hi:
          props.type === 'hospital'
            ? lastConditions?.positions_num_hi || ''
            : lastConditions?.recruitment_num_hi || ''
      },
      ai: {
        type: 'range',
        lo:
          props.type === 'hospital'
            ? lastConditions?.income_lo || ''
            : lastConditions?.s_salary3_num_lo || '',
        hi:
          props.type === 'hospital'
            ? lastConditions?.income_hi || ''
            : lastConditions?.s_salary3_num_hi || ''
      },
      sn: {
        type: 'range',
        lo:
          props.type === 'hospital'
            ? lastConditions?.shifts_num_lo || ''
            : lastConditions?.s_shifts3_num_lo || '',
        hi:
          props.type === 'hospital'
            ? lastConditions?.shifts_num_hi || ''
            : lastConditions?.s_shifts3_num_hi || ''
      }
    })

    // 検索条件から検索結果URLを組み立て
    const conditionsPath = computed(() => {
      let path = ''

      Object.keys(currentConditions).forEach((key: string) => {
        if (
          currentConditions[key].type === 'array' &&
          currentConditions[key].values.length > 0
        ) {
          currentConditions[key].values.sort((a: any, b: any) => a - b)
          path += `/${key}_` + currentConditions[key].values.join('+')
        }
        if (currentConditions[key].type === 'range') {
          if (
            currentConditions[key].lo === '' &&
            currentConditions[key].hi === ''
          )
            return
          path += `/${key}_${currentConditions[key].lo}-${currentConditions[key].hi}`
        }
        if (
          currentConditions[key].type === 'boolean' &&
          currentConditions[key].checked
        ) {
          path += `/${key}_1`
        }
      })

      return path
    })

    // 選択している条件の表示用データ
    const conditionsQuery = computed(() =>
      getSearchQuery(conditionsPath.value, props.type)
    )

    // 選択している都道府県の表示用データ
    const selectedPrefecture = computed(() => {
      const res = []
      for (let i = 0; i < currentConditions.pr.values.length; i++) {
        for (let j = 0; j < store.state.master.prefectures.length; j++) {
          if (
            currentConditions.pr.values[i] ===
            store.state.master.prefectures[j].opt_id
          ) {
            res.push(store.state.master.prefectures[j].option_name)
            continue
          }
        }
      }
      return res.join('  ')
    })

    /* --------------------------------------------------
    * アクション
    -------------------------------------------------- */

    // 現在の検索条件で検索結果が何件か取得
    const getCount = axiosSetting('app', 'block')
    const resultCount = ref(0)
    const resultCountURL = props.type === 'hospital' ? 'j_search' : 's_search'
    const getSearchResultCount = () => {
      getCount({
        method: 'get',
        url: `/api/v1/${resultCountURL}/cnt`,
        params: getSearchQuery(conditionsPath.value, props.type)
      }).then((res) => (resultCount.value = res.data.total_num))
    }
    onMounted(getSearchResultCount)

    // チェックボックス更新
    const setConditionsCheckbox = (
      target: string,
      ev: { value: string; checked: boolean }
    ) => {
      if (target === 'other') {
        const key = String(ev.value)
        currentConditions[key].checked = ev.checked
        getSearchResultCount()
        return
      }
      if (currentConditions[target].type === 'array') {
        const arr = currentConditions[target].values
        if (ev.checked && arr.indexOf(ev.value) === -1) arr.push(ev.value)
        if (!ev.checked && arr.indexOf(ev.value) > -1)
          arr.splice(arr.indexOf(ev.value), 1)
      }
      getSearchResultCount()
    }

    // 都道府県のチェック
    const checkPrefecture = (index: number, prefecture: any) => {
      areas[index].prefectures.forEach((item: Pref) => {
        if (prefecture.value === item.value) item.checked = prefecture.checked
      })
      setConditionsCheckbox('pr', prefecture)
    }

    // エリアで選択
    const selectArea = (index: number, select: boolean) => {
      areas[index].prefectures.forEach((item: Pref) => {
        item.checked = select

        const arr = currentConditions['pr'].values
        if (select && arr.indexOf(item.value) === -1) {
          arr.push(item.value)
        }

        if (!select && arr.indexOf(item.value) > -1) {
          arr.splice(arr.indexOf(item.value), 1)
        }
      })
      getSearchResultCount()
    }

    // セレクトボックス更新
    const setConditionsRange = (
      target: string,
      type: string,
      value: string
    ) => {
      if (type === 'low') currentConditions[target].lo = value
      if (type === 'high') currentConditions[target].hi = value
      getSearchResultCount()
    }

    // 検索実行
    const searchSubmit = (type: string) => {
      const url = `/search/${props.type}/list`
      store.dispatch('closeSearchModal')

      if (type === 'freeword') {
        router.push(`${url}/fw_${freeWord.value}`)
        return
      }

      if (props.formMode !== 'default') return

      store.commit('updateSearchSubmit', true)
      router.push(url + conditionsPath.value)
    }

    // 保存ボタンフラグ切り替え
    const setSaveFlg = (ev: { value: string; checked: boolean }) =>
      store.commit('setSearchCoditionSaveFrg', ev.checked)

    // 検索条件をリセット
    const clearConditions = () => {
      const form = document.getElementById(`searchForm-${props.type}`)

      if (form) {
        form
          .querySelectorAll('input[type="checkbox"]')
          .forEach((el: any) => (el.checked = false))
        form
          .querySelectorAll('input[type="text"]')
          .forEach((el: any) => (el.value = ''))
        form.querySelectorAll('select').forEach((el: any) => (el.value = ''))
      }

      Object.keys(currentConditions).forEach((key: string) => {
        if (currentConditions[key].type === 'array')
          currentConditions[key].values = []
        if (currentConditions[key].type === 'range') {
          currentConditions[key].lo = ''
          currentConditions[key].hi = ''
        }
        if (currentConditions[key].type === 'boolean')
          currentConditions[key].checked = false
      })

      freeWord.value = ''
      getSearchResultCount()
    }

    return {
      resultCount,
      freeWord,
      programSubjects,
      isShowAllProgramSubjects,
      hospitalClass,
      featureTag,
      designatedHospital,
      keywords,
      isShowAllKeywords,
      otherConditions,
      bedNumList,
      doctorNumList,
      departmentBedNumList,
      residentNumList,
      instructorNumList,
      positionsNumList,
      incomeList,
      shiftsNumList,
      currentConditions,
      conditionsQuery,
      selectedPrefecture,
      setConditionsCheckbox,
      setConditionsRange,
      searchSubmit,
      setSaveFlg,
      clearConditions,
      numberFormatAddComma,
      areas,
      selectArea,
      checkPrefecture
    }
  }
})
</script>

<style lang="scss" scoped>
@use 'src/styles/abstracts/mixins';
@use 'src/styles/abstracts/variables' as var;

.searchKeyword {
  margin-bottom: 50px;
}

.searchform {
  padding-bottom: 180px;
}
.searchformSec {
  & + & {
    margin-top: 40px;
  }

  .input {
    margin-top: 20px;
  }

  .button {
    margin-top: 24px;
  }
}

.searchformRange {
  display: flex;
  align-items: center;
  margin-left: -7px;
  margin-right: -7px;
  padding-top: 20px;

  &_between {
    padding-left: 8px;
    padding-right: 8px;
  }
}

.selectboxes {
  width: 100%;
}

.searchformSelectedTag {
  position: fixed;
  z-index: 1;
  top: 56px;
  left: 0;

  @include mixins.media() {
    display: none;
  }
}

.searchformBar {
  position: fixed;
  bottom: 0;
  left: 0;
  width: 100%;
  z-index: 1000;
  background-color: #fff;
  box-shadow: 0px -3px 6px rgba(0, 0, 0, 0.08);
  padding-top: 6px;

  &_inner {
    height: 72px;
    display: flex;
    align-items: center;
    justify-content: center;
    padding-right: 16px;
    padding-left: 16px;

    @include mixins.media() {
      margin-right: auto;
      margin-left: auto;
      padding-right: 20px;
      padding-left: 20px;
      max-width: 752px;
    }
  }

  &_reset {
    text-align: center;
    color: var.$color-main;
    margin-bottom: 12px;
  }
}

.searchformBtn {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 50px;
  max-width: 240px;
  flex-shrink: 0;
  flex-grow: 2;
  margin-right: 20px;
  border-radius: 40px;
  box-shadow: 0 3px 6px rgba(0, 0, 0, 0.16);
  font-weight: bold;
  font-size: 1.4rem;
  text-align: center;
  background-color: var.$color-main;
  border-color: var.$color-main;
  color: var.$color-white;
  padding-left: 24px;
  padding-right: 24px;

  &:hover {
    background-color: #27b7af;
    opacity: 1;
  }

  span {
    color: #fffccb;
  }
}
</style>
